// Generic type guard factory for multi-level content types
export const createBlockTypeGuard = (type) => {
    return (block) => {
        return block.contentType[1] === type;
    };
};
// Create type guards for each block type
export const isColumnsBlock = createBlockTypeGuard('ColumnsBlock');
export const isTitleBlock = createBlockTypeGuard('TitleBlock');
export const isPromoMainBlock = createBlockTypeGuard('PromoMainBlock');
export const isLogosBlock = createBlockTypeGuard('LogosBlock');
export const isParallaxBlock = createBlockTypeGuard('ParallaxBlock');
export const isTabsBlock = createBlockTypeGuard('TabsBlock');
export const isHeroHomeBlock = createBlockTypeGuard('HeroHomeBlock');
export const isHighlightsBlock = createBlockTypeGuard('HighlightsBlock');
export const isResourcePreviewCardsBlock = createBlockTypeGuard('ResourcePreviewCardsBlock');
export const isTwoColumnBlock = createBlockTypeGuard('TwoColumnBlock');
